const slideshowInitialTimeout = 2000;
const slideshowInterval = 4000;

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
// https://davidwalsh.name/javascript-debounce-function
function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
      args = arguments;
    var later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

// to set header dark or light when scrolling. Can it be change?
headerCheck = () => {
  const header = document.querySelector('header');
  if (header === null) {
    return;
  }

  let addColorCheckToScrollEvent = true;

  const pageContent = document.querySelector('.page-content');
  if (pageContent === null) {
    addColorCheckToScrollEvent = false;
  }

  let isHeaderDark = header.classList.contains('dark');
  let headerWasDark = isHeaderDark;
  let isHeaderTransparent = header.classList.contains('transparent');
  let headerWasTransparent = isHeaderTransparent;
  
  if (header.classList.contains('light')) {
    addColorCheckToScrollEvent = false;
  }

  const checkHeaderColor = () => {
    const top =
      (window.pageYOffset || document.scrollTop) - (document.clientTop || 0);
    if (!isNaN(top) && top > 10) {
      if (isHeaderDark) {
        header.classList.remove('dark');
        isHeaderDark = false;
      } else if (isHeaderTransparent) {
        header.classList.remove('transparent');
        isHeaderTransparent = false;
      }
      header.classList.add('light');
    } else if ((isNaN(top) || top <= 10)) {
      if (!isHeaderDark && headerWasDark) {
        header.classList.add('dark');
        isHeaderDark = true;
      } else if (!isHeaderTransparent && headerWasTransparent) {
        header.classList.add('transparent');
        isHeaderTransparent = true;
      }
      header.classList.remove('light');
      
      setTimeout(() => {
        // Safari has a bug
        header.parentNode.style.cssText += '-webkit-transform:rotateZ(0deg);';
        header.parentNode.offsetHeight;
        header.parentNode.style.cssText += '-webkit-transform:none;';
      });
    }

    // // Safari has a bug
    // header.parentNode.style.cssText += '-webkit-transform:rotateZ(0deg);';
    // header.parentNode.offsetHeight;
    // header.parentNode.style.cssText += '-webkit-transform:none;';
  };

  addColorCheckToScrollEvent ? checkHeaderColor() : false;

  window.onscroll = () => {
    // Removed by JFL to avoid unpin menu.
    // debounce(checkHeaderShowOrHide, 50)();
    addColorCheckToScrollEvent ? debounce(checkHeaderColor, 50)() : false;
  };
};

activateDetailsToggle = () => {
  const toggles = document.querySelectorAll('.toggle-card-details');
  toggles.forEach((toggle) => {
    toggle.onclick = () => {
      const toggled = toggle.getAttribute('data-toggled');
      const toggledId = toggle.getAttribute('data-toggled-id');
      const toggledElement = document.querySelector(toggledId);

      if (toggled === 'true') {
        toggledElement.classList.add('hidden');
        toggle.innerHTML = 'Show Details <span class="plus-sign">&plus;</span>';
        toggle.setAttribute('data-toggled', 'false');
      } else {
        toggledElement.classList.remove('hidden');
        toggle.innerHTML =
          'Hide Details <span class="minus-sign">&minus;</span>';
        toggle.setAttribute('data-toggled', 'true');
      }
    };
  });
};

setLastPageSeen = () => {
  // The if is there to avoid replacing the ObkioLastPageSeen if the current page is reloaded.
  if (window.location.href != window.localStorage.getItem('ObkioCurrentPage')) {
    window.localStorage.setItem(
      'ObkioLastPageSeen',
      window.localStorage.getItem('ObkioCurrentPage'),
    );
    window.localStorage.setItem('ObkioCurrentPage', window.location.href);
  }
};

getUTMTags = () => {
  const expected_tags = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
  ];
  let utm_template = {
    utm_source: '',
    utm_medium: '',
    utm_campaign: '',
    utm_term: '',
    utm_content: '',
  };
  let local_data = JSON.parse(window.localStorage.getItem('utm_tags'));
  if (!local_data) {
    local_data = [];
    window.localStorage.setItem('utm_tags', JSON.stringify(local_data));
  }
  const args = window.location.search.substring(1);
  const couples = args.split('&');
  let vars = [];
  let new_tag = false;
  couples.forEach(function (value) {
    vars.push(value.split('='));
  });
  vars.forEach(function (couple) {
    const index = expected_tags.indexOf(couple[0]);
    if (index != -1) {
      utm_template[expected_tags[index]] = couple[1];
      new_tag = true;
    }
  });
  if (new_tag) {
    local_data.push(utm_template);
    window.localStorage.setItem('utm_tags', JSON.stringify(local_data));
  }
};

document.body.onload = () => {
  headerCheck();
  // showMenusOnHover();
  registerMobileNavigationToggle();

  // used on /monitoring-agent
  activateDetailsToggle();

  // Confirm Email
  // confirmEmail();

  // Store UTM tags
  getUTMTags();

  // Add scripts to all pages
  addScripts();

  // Store Last Page Seen
  setLastPageSeen();
};

// Tabs
toggleActive = (menu, bloc) => {
  var i, tabcontent, tablinks, isActive;
  if (window.matchMedia('(max-width: 768px)').matches) {
    if (bloc.classList.contains('active')) {
      isActive = true;
    } else {
      isActive = false;
    }
  }

  tabcontent = document.getElementsByClassName('bloc');
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].classList.remove('active');
  }
  tablinks = document.getElementsByTagName('div');
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].classList.remove('active');
  }
  if (!isActive) {
    bloc.classList.add('active');
    menu.classList.add('active');
  }
  if (window.matchMedia('(max-width: 768px)').matches) {
    menu.scrollIntoView();
  }
};

// toggleDropdown = (dropdown) => {
//   if (dropdown.classList.contains('hidden')) {
//     dropdown.classList.remove('hidden');
//   } else {
//     dropdown.classList.add('hidden');
//   }
// };

showMobileNavigation = () => {
  document.querySelector('body').style.overflow = 'hidden';

  document
    .querySelector('#o-mobile-navigation-toggle')
    .classList.add('pure-menu-active');
  document
    .querySelector('#o-mobile-navigation-menu')
    .setAttribute('aria-hidden', 'false');
  document.querySelector('#o-mobile-navigation-menu').style = '';

  setTimeout(() => {
    document.addEventListener('click', handleClickOnDocument);
  }, 300);
};

hideMobileNavigation = () => {
  document.querySelector('body').style.overflow = 'auto';

  const isVisible = document
    .querySelector('#o-mobile-navigation-toggle')
    .classList.contains('pure-menu-active');
  if (isVisible) {
    document
      .querySelector('#o-mobile-navigation-toggle')
      .classList.remove('pure-menu-active');
    document
      .querySelector('#o-mobile-navigation-menu')
      .setAttribute('aria-hidden', 'true');
  }

  document.removeEventListener('click', handleClickOnDocument);
};

handleClickOnDocument = (event) => {
  let menu = document.getElementById('o-mobile-navigation-menu');

  let clickedOnMenu = menu.contains(event.target);

  if (!clickedOnMenu) {
    hideMobileNavigation();
  }
};

goToUrl = (url) => {
  window.location.assign(url);
};

registerMobileNavigationToggle = () => {
  let menuToggle = document.querySelector('#o-mobile-navigation-toggle');

  if (!menuToggle) {
    return;
  }

  menuToggle.addEventListener('click', () => {
    if (!menuToggle.classList.contains('pure-menu-active')) {
      showMobileNavigation();
    }
  });
};

// function addEventListenerList(list, event, fn) {
//   list.forEach((item) => {
//     item.addEventListener(event, fn);
//   });
// }

// showMenusOnHover = () => {
//   let productsTimeout = 0;

//   const productsMenu = document.querySelectorAll('#products-sub-menu-desktop, .products-menu-item');

//   const productsMenuToShow = document.querySelector('#products-sub-menu-desktop');

//   addEventListenerList(productsMenu, 'mouseenter', () => {
//     clearTimeout(productsTimeout);
//     showMenu(productsMenuToShow);
//   });

//   addEventListenerList(productsMenu, 'mouseleave', () => {
//     productsTimeout = setTimeout(() => {
//       hideMenu(productsMenuToShow);
//     }, 100);
//   });
// };

// function showMenu(menu) {
//   menu.classList.remove('hidden');
// }

// function hideMenu(menu) {
//   menu.classList.add('hidden');
// }
